"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTotalTransactions = void 0;
var end2end_1 = require("@hudled/end2end");
var getTotalTransactions = function (num) { return (0, end2end_1.handlePlural)('Transaction')(num, 'No'); };
exports.getTotalTransactions = getTotalTransactions;
